<template>
  <ZMainPage v-loading="loading">
    <div class="line-group b-b pt-2 user-info" v-if="!isAdd">
      <div class="line-item b-r" v-for="(item, index) in list1" :key="index">
        <span class="label">{{ item.label }}</span>
        <span class="value text-primary">{{ item.value }}</span>
      </div>
    </div>
    <el-form ref="form" :model="formData" :rules="rules" labelWidth="150rem" label-position="left">
      <div class="line-group b-b" v-if="isAdd">
        <div class="line-item">
          <el-form-item label="客户姓名" prop="name">
            <el-input v-model="formData.name" maxlength="15" placeholder="请输入"></el-input>
          </el-form-item>
        </div>
        <div class="line-item">
          <el-form-item label="客户联系电话" prop="phone">
            <el-input v-model="formData.phone" maxlength="11" placeholder="请输入"></el-input>
          </el-form-item>
        </div>
        <div class="line-item">
          <el-form-item label="" label-width="0"><span class="mr-3 text-muted">获取工具</span>{{ info.tools }}</el-form-item>
        </div>
      </div>
      <div class="line-group" v-if="isCanEditName">
        <div class="line-item">
          <el-form-item label="客户姓名">
            <el-input v-model="formData.name" maxlength="15" placeholder="请输入"></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="line-group">
        <div class="line-item">
          <el-form-item label="线索渠道" v-if="showSource"><div class="el-input">{{ showSource }}</div></el-form-item>
          <el-form-item label="线索渠道" prop="source" v-else>
            <el-select v-model="formData.source" placeholder="请选择">
              <el-option v-for="item in options5" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </div>
        <div class="line-item" v-if="showName">
          <el-form-item label="客户与学生的关系"><div class="el-input">{{ showName }}</div></el-form-item>
        </div>
        <template v-else>
          <div class="line-item">
            <el-form-item label="客户与学生的关系" prop="relationship">
              <el-select v-model="formData.relationship" placeholder="请选择">
                <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </div>
          <div class="line-item" v-if="formData.relationship === 8">
            <el-form-item label="实际关系" prop="real_relationship">
              <el-input v-model="formData.real_relationship" maxlength="10" show-word-limit placeholder="请输入"></el-input>
            </el-form-item>
          </div>
        </template>
        <div class="line-item" v-if="!isAdd">
          <el-form-item label="" label-width="0"><span class="mr-3 text-muted">获取工具</span>{{ info.tools }}</el-form-item>
        </div>
      </div>
      <div class="line-group b-b">
        <div class="line-item">
          <el-form-item label="咨询校区" prop="school">
            <el-select v-model="formData.school" placeholder="请选择">
              <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </div>
        <div class="line-item">
          <el-form-item label="其他联系方式" prop="other_contact">
            <el-input v-model="formData.other_contact" maxlength="20" show-word-limit placeholder="请输入"></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="line-group">
        <div class="line-item">
          <el-form-item label="跟进状态" prop="status">
            <el-select v-model="formData.status" placeholder="请选择">
              <el-option v-for="item in options3" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </div>
        <div class="line-item">
          <el-form-item label="意向评级" prop="level">
            <el-select v-model="formData.level" placeholder="请选择">
              <el-option v-for="item in options4" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </div>
      </div>
      <div class="line-group">
        <div class="line-item">
          <el-form-item label="本次跟进的内容说明" class="is-single">
            <span slot="label" style="float: none !important; word-break: break-word !important;">本次跟进的内容说明</span>
            <el-input v-model="formData.content" placeholder="请输入" type="textarea" maxlength="300" show-word-limit :autosize="{ minRows: 4, maxRows: 6 }"></el-input>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <div class="other-info" v-if="!isAdd && info.subjects">
      <div class="other-title mb-2">其他信息</div>
      <div class="other-tips flex mb-2">
        <div class="text-muted mr-6">地区</div>
        <div class="mr-10">{{ info.address }}</div>
        <div class="text-muted mr-6 pl-4">总分</div>
        <div>{{ info.total }}</div>
      </div>
      <div class="other-table mb-2">
        <div class="flex line title">
          <div class="item" v-for="(item, index) in info.subjects" :key="index">{{ item }}</div>
        </div>
        <div class="flex line content">
          <div class="item" v-for="(item, index) in info.scores" :key="index">{{ item }}</div>
        </div>
      </div>
      <div class="other-content">{{ info.content }}</div>
    </div>
    <Dialog :visible.sync="visible" title="跟进记录" :showFooter="false">
      <TimeLine :list="list2" reverse v-loading="loading2"></TimeLine>
    </Dialog>
    <template #footer>
      <el-button type="primary" @click="handleSubmit('form')">提交</el-button>
      <el-button v-if="!isAdd" @click="handleVisible">跟进记录</el-button>
      <el-button @click="handleBack('form')">取消</el-button>
    </template>
  </ZMainPage>
</template>

<script>
import Dialog from "@/components/common/Dialog";
import TimeLine from "@/components/common/TimeLine";
import http from "@/api";
import { changeOption } from "@/utils";
export default {
	_config:{"route":[{"path":"detail","meta":{"title":"跟进"}}, {"path":"add","meta":{"title":"新增"}}]},
  components: { Dialog, TimeLine },
  data() {
    const validatorPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'))
      } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error('请输入正确手机号'))
      } else {
        callback()
      }
    }
    const validatorName = (rule, value, callback) => {
      if (value && value.length > 15) {
        callback(new Error('名字限制15个字'))
      } else {
        callback()
      }
    }
    const validatorRelationship = (rule, value, callback) => {
      if (!value & this.formData.relationship === 8) {
        callback(new Error('请输入实际关系'))
      } else {
        callback()
      }
    }
    return {
      info: { tools: '手动录入', },
      formData: { source:'', name: '', phone: '', relationship:'', real_relationship: '', school: '', other_contact: '', status: '', level: '', content: '' },
      rules: {
        name: [{ required: false, validator: validatorName, trigger: 'blur' }],
        phone: [{ required: true, validator: validatorPhone, trigger: 'blur' }],
        relationship: [{ required: false, message: '请选择', trigger: 'change' }],
        real_relationship: [{ required: true, validator: validatorRelationship, trigger: 'blur' }],
        school: [{ required: false, message: '请选择', trigger: 'change' }],
        other_contact: [{ required: false, message: '请输入', trigger: 'blur' }],
        status: [{ required: false, message: '请选择', trigger: 'change' }],
        level: [{ required: false, message: '请选择', trigger: 'change' }],
      },
      options1: [],
      options2: [],
      options3: [],
      options4: [],
      options5: [],
      list1: [],
      list2: [],
      visible: false,
      isRequest: false,
      loading: false,
      loading2: false,
      isAdd: false,
      isCanEditName: false,
      id: 0,
      showName: '',
      showSource: ''
    }
  },
  created() {
    this.id = Number(this.$route.query.id) || 0
    this.getConfig()
    this.getData()
    if(this.$route.path.includes('add')) {
      this.isAdd = true
    }
  },
  methods: {
    getConfig() {
      http.get('/zhaosheng/api/crm/thread-config?type=2').then(res => {
        const { recruit_status = [], recruit_relationship = [], level = [], recruit_school = [] } = res
        this.options1 = changeOption({ list: recruit_relationship, label: 'name', value: 'id' })
        this.options2 = changeOption({ list: recruit_school, label: 'school_name', value: 'id' })
        this.options3 = changeOption({ list: recruit_status, label: 'name', value: 'id' }).filter(item => item.value)
        this.options4 = changeOption({ list: level, label: 'name', value: 'id' })
      })
      http.get('/zhaosheng/api/crm/search-source?type=2', { keyword: '' }).then(res => {
        this.options5 = res.map(item => ({ ...item, label: item.source, value: item.id }))
      })
    },
    getData() {
      if(!this.id) return
      this.loading = true
      http.get('/zhaosheng/api/crm/thread-detail', { id: this.id }).then(res => {
        const { source, name, import_name, phone, creator, created_at, real_relationship, status, level, relationship, other_contact, school, content, source_name, relationship_map, obtain_tools, score_json, score_total, config_content, province_name, city_name, area_name } = res
        const data = { total: score_total, content: config_content, address: province_name + city_name + area_name, tools: obtain_tools }
        if (score_json && score_json.length) {
          let subjects = [], scores = []
          score_json.map(item => {
            subjects.push(item.name)
            scores.push(item.score)
          })
          data.subjects = subjects
          data.scores = scores
        }
        this.info = data
        let arr = [
          { label: '客户联系电话', value: phone },
          { label: '线索归属人', value: creator || '-' },
          { label: '线索录入时间', value: created_at }
        ]
        if(name) {
          arr.unshift({ label: '客户姓名', value: name })
        } else {
          this.isCanEditName = true
          this.formData.name = import_name
        }
        this.list1 = arr
        this.formData.source = source
        this.formData.relationship = relationship
        this.formData.real_relationship = real_relationship
        this.formData.school = school
        this.formData.other_contact = other_contact
        this.formData.status = status || ''
        this.formData.level = level
        this.formData.content = content
        if(relationship) {
          const relationshipObj = relationship_map.find(item => item.id === relationship)
          this.showName = real_relationship || relationshipObj?.name || ''
        }
        if(source) {
          this.showSource = source_name
        }
      }).finally(()=> this.loading = false)
    },
    getRecord() {
      this.loading2 = true
      http.get('/zhaosheng/api/recruit/common/get-opt-history', { tbl_name:'user_thread', tbl_id: this.id }).then(res => {
        const { list = [] } = res
        this.list2 = list.map(i => ({ content: i.change_detail }))
        this.isRequest = true
      }).finally(() => this.loading2 = false)
    },
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if(valid) {
          const { name, phone, ...other } = this.formData
          const data = { ...other }
          if(this.isAdd) {
            data.name = name
            data.phone = phone
            data.type = 2
          } else {
            data.id = this.id
            if(this.isCanEditName) {
              data.name = name
            }
          }
          if(data.relationship !== 8) data.real_relationship = ''
          const api =  `/zhaosheng/api/crm/${this.isAdd ? 'add-thread' : 'update-thread-info'}`
          this.loading = true
          http.post(api, data).then(res => {
            this.$router.back()
          }).finally(()=> this.loading = false)
        }
      })
    },
    handleBack(name) {
      this.$router.back()
    },
    handleVisible() {
      this.visible = true
      if(!this.isRequest) this.getRecord()
    }
  }
}
</script>

<style lang="scss" scoped>
.line-group {
  display: flex;
  &.b-b {
    padding-bottom: 8rem;
    margin-bottom: 30rem;
  }
}
.line-item {
  &:not(:last-child) {
    margin-right: 50rem;
  }
  &:only-child {
    width: 70%;
  }
}
.user-info {
  .line-item {
    position: relative;
    margin-bottom: 22rem;
    margin-right: 24rem;
    padding-right: 24rem;
    font-size: 16rem;
    &:last-child{
      border-right: none;
    }
    .label {
      margin-right: 24rem;
    }
  }
}
.other {
  &-info {
    margin-top: 24rem;
  }
  &-title {
    font-size: 18rem;
    font-weight: 600;
  }
  &-tips {
    font-size: 16rem;
  }
  &-table {
    .line {
      border-left: solid 1px #DBDDE4;
    }
    .title {
      .item {
        background-color: #F6F9FF;
        border-top: solid 1px #DBDDE4;
      }
    }
    .item {
      width: 124rem;
      line-height: 40rem;
      text-align: center;
      border-right: solid 1px #DBDDE4;
      border-bottom: solid 1px #DBDDE4;
    }
  }
  &-content {
    width: 70%;
    padding: 14rem;
    color: #3C3C3C;
    line-height: 1.4;
    border: solid 1px #DCDFE6;
    border-radius: 4rem;
  }
}
</style>
